import {match, Pattern} from 'ts-pattern';

import {VehicleWarehouseMotLayout} from '../../../utils/getVehicleWarehouseMotLayout';
import {FocusedVehicleMotContent} from '../types/FocusedVehicleMotContent';

export function wouldRemoveFocusedVehicleMotContent(
  focusedContent: FocusedVehicleMotContent | null,
  nextLayout: VehicleWarehouseMotLayout
) {
  return match({focusedContent, nextLayout})
    .with({focusedContent: Pattern.nullish}, () => false)
    .with(
      {focusedContent: Pattern.nonNullable, nextLayout: {mode: 'aggregate'}},
      (matched) => matched.focusedContent.mode === 'detail'
    )
    .with({focusedContent: {rowIndex: Pattern.nullish}}, () => false)
    .with({focusedContent: {rowIndex: Pattern.number.and(Pattern.when(Number.isNaN))}}, () => true)
    .with(
      {focusedContent: {category: 'expired', rowIndex: Pattern.number}},
      (matched) => matched.focusedContent.rowIndex >= matched.nextLayout.rows.expired
    )
    .with(
      {focusedContent: {rowIndex: Pattern.number}},
      (matched) => matched.focusedContent.rowIndex >= matched.nextLayout.rows.expiring
    )
    .otherwise(() => false);
}
